import { render, staticRenderFns } from "./reportPatriarch.vue?vue&type=template&id=72789002&scoped=true&"
import script from "./reportPatriarch.vue?vue&type=script&lang=js&"
export * from "./reportPatriarch.vue?vue&type=script&lang=js&"
import style0 from "./reportPatriarch.vue?vue&type=style&index=0&id=72789002&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72789002",
  null
  
)

component.options.__file = "reportPatriarch.vue"
export default component.exports